import * as angular from 'angular';
import * as _ from 'lodash';

import { Group, ComponentDefinition } from '../../../models';

class MapToExistingModalController implements angular.IComponentController {
    dragObject: any;
    groups: Group[];
    group: Group;
    selectedGroup: Group;
    initialGroup: Group;
    isLoading: boolean;
    yesFunction: (value: { group: Group, dragObject: any }) => void;
    mode: 'Create' | 'Update';
    id: string;

    static $inject = ['$scope', '$timeout'];

    constructor(
        private _$scope: angular.IScope,
        private _$timeout: angular.ITimeoutService
    ) {
    }

    $onInit() {
        this.mode = 'Create';
        const modalName = 'mapGroupModal';
        this._$timeout(() =>
            angular.element(`#${modalName}`)
                .on('shown.bs.modal', () => {
                    if (_.some(this.groups, g => g.guid === this.initialGroup.guid)) {
                        this.mode = 'Update';
                        this.selectedGroup = _.find(this.groups, g => g.guid === this.initialGroup.guid);
                    } else {
                        this.mode = 'Create';
                        this.selectedGroup = null;
                    }
                    this._$scope.$apply();
                })
        );
    }

    map() {
        const selectedGroup = this.mode === 'Create'
            ? this.initialGroup
            : this.selectedGroup;

        this.yesFunction({ group: selectedGroup, dragObject: this.dragObject });
    }

    select(group: Group): void {
        if (this.mode !== 'Update') {
            this.mode = 'Update';
        }
        this.selectedGroup = group;
    }

    isInvalid() {
        return this.mode === 'Update' && !this.selectedGroup;
    }
}

export const wtIdentifiersMappingState: ComponentDefinition = {
    componentId: 'wtMapToExistingModal',
    controller: MapToExistingModalController,
    controllerAs: 'vm',
    template: require('./mapToExistingModal.component.html'),
    bindings: {
        dragObject: '<',
        id: '@',
        initialGroup: '=',
        groups: '<',
        yesFunction: '&'
    }
};